<template>
    <ReferralLayout>
        <div>
            <Toast v-if="toast" :key="toast" :toast="toast" id="emailSent"/>
            <WelcomeDashboard :referral-partner="referralPartner"/>
            <div class="mb-4">
                <div class="text-h5 font-weight-bold mb-2 text-[#0676C2]">{{ $t('referrers.Spread the word') }}</div>
                <div class="text-body-2">{{ $t('referrers.We offer you multiple ways to share the love') }} </div>
            </div>
            <div>
                <div class="text-body-2 font-weight-bold">{{ $t('referrers.Share on social') }}</div>
                <div class="text-body-2">{{ $t('referrers.Invite friends on social networks') }}</div>
                <v-row class="my-4" no-gutters>
                    <v-col cols="12" sm="12" md="3" lg="2" xl="2">
                        <SocialButtons :url="referralLink"/>
                    </v-col>
                    <v-col cols="12" sm="12" md="7" lg="7" xl="7" class="mt-3 mt-md-0 mt-lg-0 mt-xl-0">
                        <v-text-field variant="outlined" density="comfortable" readonly :prepend-inner-icon="$vuetify.display.mdAndUp?'mdi-link-variant':''" class="overflow-x-hidden">
                            {{ referralLink }}
                            <v-btn v-if="$vuetify.display.smAndDown" block color="primary" size="small" @click="copyLink">{{ $t('referrers.Copy link') }}</v-btn>
                            <template v-slot:append-inner v-if="$vuetify.display.mdAndUp">
                                <v-btn color="primary" size="small" @click="copyLink">{{ $t('referrers.Copy link') }}</v-btn>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
            </div>
            <div>
                <div class="text-body-2 font-weight-bold">{{ $t('referrers.Invite a friend yourself') }}</div>
                <div class="text-body-2">{{ $t('referrers.Already know what friends you want to refer') }}</div>
                <v-form @submit.prevent="inviteSubmit" autocomplete="off">
                    <v-row class="my-4">
                        <input role="presentation" autocomplete="off" style="display: none" />
                        <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                            <v-text-field v-model="invite.full_name" variant="outlined" density="comfortable" :placeholder="$t('referrers.Name of your friend')" :rules="[rules.required]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                            <v-text-field v-model="invite.email" variant="outlined" autocomplete="off"
                                          aria-autocomplete="none" density="comfortable"
                                          :placeholder="$t('Email')" :rules="[rules.required, rules.email]"
                                          :error-messages="errors.email ? [errors.email[0]] : []"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                            <v-text-field v-model="invite.phone" variant="outlined" density="comfortable" :placeholder="$t('Phone')"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="2" lg="2" xl="2">
                            <v-btn type="submit" block color="primary" size="x-large" density="comfortable" class="text-body-2 font-weight-bold py-6">{{ $t('referrers.Send invite') }}</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </div>
            <ReferralsDashboard :referrals="yourReferrals" :emails="emails"/>
<!--            <PayoutsDashboard :payouts="payouts" class="my-10"/>-->
        </div>
    </ReferralLayout>
</template>

<script>
import WelcomeDashboard from "../../Components/ReferralCampaigns/dashboard/WelcomeDashboard";
import ReferralsDashboard from "../../Components/ReferralCampaigns/dashboard/ReferralsDashboard";
import PayoutsDashboard from "../../Components/ReferralCampaigns/dashboard/PayoutsDashboard";
import ReferralLayout from "../../Layouts/ReferralLayout";
import SocialButtons from "@/Components/Campaigns/SocialButtons.vue";
import Toast from "@/Components/Toast";

export default {
    name: "Dashboard",
    components: {
        SocialButtons,
        WelcomeDashboard,
        ReferralsDashboard,
        PayoutsDashboard,
        ReferralLayout,
        Toast
    },
    props: {
        toast: {
            type: Object,
            required: false,
        },
        referralPartner: {
            type: Object,
            required: true,
        },
        yourReferrals: {
            type: Array,
            required: true,
        },
        referralLink: {
            type: String,
            required: true,
        },
        emails: {
            type: Array,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            invite: {
                referral_id: null,
                full_name:'',
                email:'',
                phone:'',
            },
            rules: {
                required: value => !!value || this.$t('referrers.Field is required'),
                email: value => !value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || this.$t('referrers.E-mail must be valid'),
                // phone: value => !value || /^0\d{8,10}$/.test(value) || 'Phone must be valid'
            },
        };
    },
    methods: {
        async inviteSubmit(e) {
            e.preventDefault();
            e.stopPropagation();
            let res = await e;
            if (!res.valid) return;
            this.invite.referral_id = this.referralPartner.id;
            this.$inertia.post(this.route("referral.invite-friend-by-email"), this.invite);
        },
        copyLink() {
            navigator.clipboard.writeText(this.referralLink).then(
                () => {
                    /* clipboard successfully set */
                },
                () => {
                    /* clipboard write failed */
                    alert(this.$t('Failed to copy text do it manually'))
                }
            );
        }
    }

}
</script>

<style scoped>

</style>
